var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavExplore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 9.84784 20.9464 7.3043 19.0711 5.42893C17.1957 3.55357 14.6522 2.5 12 2.5ZM13 20.43V19.5C13 18.9477 12.5523 18.5 12 18.5C11.4477 18.5 11 18.9477 11 19.5V20.43C7.37981 19.9709 4.52909 17.1202 4.07 13.5H5C5.55228 13.5 6 13.0523 6 12.5C6 11.9477 5.55228 11.5 5 11.5H4.07C4.52909 7.87981 7.37981 5.02909 11 4.57V5.5C11 6.05228 11.4477 6.5 12 6.5C12.5523 6.5 13 6.05228 13 5.5V4.57C16.6202 5.02909 19.4709 7.87981 19.93 11.5H19C18.4477 11.5 18 11.9477 18 12.5C18 13.0523 18.4477 13.5 19 13.5H19.93C19.4709 17.1202 16.6202 19.9709 13 20.43Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1399 10.1701L15.1399 8.05005C15.5147 7.89198 15.9479 7.97671 16.2356 8.26436C16.5232 8.552 16.608 8.98523 16.4499 9.36005L14.3299 14.3601C14.2289 14.5931 14.043 14.7791 13.8099 14.8801L8.80989 17.0001C8.68491 17.0594 8.54826 17.0902 8.40989 17.0901C8.14612 17.0863 7.89452 16.9785 7.70989 16.7901C7.42189 16.5006 7.33877 16.0652 7.49989 15.6901L9.61989 10.6901C9.72088 10.457 9.9068 10.271 10.1399 10.1701ZM10.3699 14.1501L12.6499 13.1501L13.6499 10.8701L11.3699 11.8701L10.3699 14.1501Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavExplore);
export default ForwardRef;